module.exports =
  extractErrorsFromResponse: (response) ->
    if response.readyState == 0
      ["Can't connect to server"]
    else
      response.responseJSON.errors